/**
 * The main theme javascript
 *
 * @package project
 */
import App from '../../../packages/thmr/thmr/es6/app.js';
import thmr from '../thmr.json';

/**
 * Instantiate the app
 */
const app = new App( thmr );

/**
 * Add jQuery to window
 */
if ( ! window.$ && window.jQuery ) {
	window.$ = window.jQuery;
}

/**
 * Tell the module loader that jQuery has already loaded
 */
app.moduleLoader.map.jquery.loaded = true;

/**
 * Set up google maps module
 */
if ( app.googleMapsAPIKey ) {
	app.modules.push( 'google-maps' );
	app.map['google-maps'] = {
		dependencies: [],
		loaded: false,
		including: false,
		type: 'file',
		files: [
			{
				url:
					'https://maps.googleapis.com/maps/api/js?key=' +
					app.googleMapsAPIKey,
				type: 'js'
			}
		]
	};
}

/**
 * Overwrite slick slider default cdn css with our custom local css file
 * so that it automatically loads
 */
app.map.slick.files[1] = {
	url: '/wp-content/themes/project/css/slick-theme.css',
	type: 'css'
};

/**
 * Main menu
 */
app.on( 'ready', () => {
	$( 'header .menu-control' ).click( function( e ) {
		e.preventDefault();
		e.stopPropagation();
		let header = $( this ).parents( 'header' );
		let menu = header.find( '.nav' );
		header.removeClass( 'search-open' ).toggleClass( 'menu-open' );
		if ( header.hasClass( 'menu-open' ) ) {
			menu.hide()
				.stop()
				.slideDown( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		} else {
			menu.show()
				.stop()
				.slideUp( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		}
	});

	$( 'header .sub-control' ).click( function( e ) {
		e.preventDefault();
		e.stopPropagation();
		let li = $( this ).parent();
		let submenu = $( this ).siblings( 'ul' );
		li.toggleClass( 'sub-open' );
		if ( li.hasClass( 'sub-open' ) ) {
			submenu.hide()
				.stop()
				.slideDown( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		} else {
			submenu.show()
				.stop()
				.slideUp( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		}
	});
});

/**
 * Search
 */
app.on( 'ready', () => {
	$( 'header .search-control' ).click( function( e ) {
		e.preventDefault();
		e.stopPropagation();
		let header = $( this ).parents( 'header' );
		let form = header.find( 'form' );
		header.removeClass( 'menu-open' ).toggleClass( 'search-open' );
		if ( header.hasClass( 'search-open' ) ) {
			form.hide()
				.stop()
				.slideDown( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		} else {
			menu.show()
				.stop()
				.slideUp( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		}
	});

	$( 'header form input' )
		.focus( function() {
			$( 'header .custom-link' ).addClass( 'off' );
		})
		.blur( function() {
			$( 'header .custom-link' ).removeClass( 'off' );
		});
});

/**
 * Accordion
 */
app.on( 'ready', () => {
	$( '.accordion .heading' ).click( function() {
		let item = $( this ).parent();
		let text = item.find( '.text' );
		item.toggleClass( 'active' );
		if ( item.hasClass( 'active' ) ) {
			text.hide()
				.stop()
				.slideDown( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		} else {
			text.show()
				.stop()
				.slideUp( 150, function() {
					$( this ).removeAttr( 'style' );
				});
		}
	});
});

/**
 * Fancbox
 */
app.on( 'ready', () => {
	if ( 0 < $( '.fancybox' ).length ) {
		app.include( 'fancybox' ).then( () => {
			$( '.fancybox' ).fancybox();
		});
	}
});

/**
 * Slick slider
 */
app.on( 'ready', () => {
	if ( 0 < $( '.slick' ).length || 0 < $( '.multi-slick' ) ) {
		app.include( 'slick' ).then( () => {
			$( '.slick' ).each( function() {
				let el = $( this );
				el.slick({
					arrows: 'true' === el.attr( 'data-arrows' ) ? true : false,
					dots: 'true' === el.attr( 'data-dots' ) ? true : false,
					adaptiveHeight: true,
					fade: true,
					lazyLoad: 'progressive'
				});
			});
			$( '.multi-slick' ).each( function() {
				let el = $( this );
				app.include( 'images-loaded' ).then( () => {
					imagesLoaded( el, () => {
						el.slick({
							arrows: true,
							slidesToShow: 3,
							slidesToScroll: 1,
							responsive: [
								{
									breakpoint: 1024,
									settings: {
										slidesToShow: 2
									}
								},
								{
									breakpoint: 600,
									settings: {
										slidesToShow: 1
									}
								}
							]
						});
					});
				});
			});
		});
	}
});

/**
 * Google map
 */
app.on( 'ready', () => {
	if ( 0 < $( '.block.google-map .map' ).length ) {
		app.include( 'google-maps' ).then( () => {
			$( '.block.google-map .map' ).each( function() {
				let el = $( this );
				let coordinates = {
					lat: parseFloat( el.attr( 'data-latitude' ) ),
					lng: parseFloat( el.attr( 'data-longitude' ) )
				};
				let map = new google.maps.Map( el[0], {
					center: coordinates,
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: true,
					styles: [
						{
							featureType: 'all',
							elementType: 'geometry.fill',
							stylers: [
								{
									weight: '2.00'
								}
							]
						},
						{
							featureType: 'all',
							elementType: 'geometry.stroke',
							stylers: [
								{
									color: '#9c9c9c'
								}
							]
						},
						{
							featureType: 'all',
							elementType: 'labels.text',
							stylers: [
								{
									visibility: 'on'
								}
							]
						},
						{
							featureType: 'landscape',
							elementType: 'all',
							stylers: [
								{
									color: '#f2f2f2'
								}
							]
						},
						{
							featureType: 'landscape',
							elementType: 'geometry.fill',
							stylers: [
								{
									color: '#ffffff'
								}
							]
						},
						{
							featureType: 'landscape.man_made',
							elementType: 'geometry.fill',
							stylers: [
								{
									color: '#ffffff'
								}
							]
						},
						{
							featureType: 'poi',
							elementType: 'all',
							stylers: [
								{
									visibility: 'off'
								}
							]
						},
						{
							featureType: 'road',
							elementType: 'all',
							stylers: [
								{
									saturation: -100
								},
								{
									lightness: 45
								}
							]
						},
						{
							featureType: 'road',
							elementType: 'geometry.fill',
							stylers: [
								{
									color: '#eeeeee'
								}
							]
						},
						{
							featureType: 'road',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#7b7b7b'
								}
							]
						},
						{
							featureType: 'road',
							elementType: 'labels.text.stroke',
							stylers: [
								{
									color: '#ffffff'
								}
							]
						},
						{
							featureType: 'road.highway',
							elementType: 'all',
							stylers: [
								{
									visibility: 'simplified'
								}
							]
						},
						{
							featureType: 'road.arterial',
							elementType: 'labels.icon',
							stylers: [
								{
									visibility: 'off'
								}
							]
						},
						{
							featureType: 'transit',
							elementType: 'all',
							stylers: [
								{
									visibility: 'off'
								}
							]
						},
						{
							featureType: 'water',
							elementType: 'all',
							stylers: [
								{
									color: '#46bcec'
								},
								{
									visibility: 'on'
								}
							]
						},
						{
							featureType: 'water',
							elementType: 'geometry.fill',
							stylers: [
								{
									color: '#c8d7d4'
								}
							]
						},
						{
							featureType: 'water',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#070707'
								}
							]
						},
						{
							featureType: 'water',
							elementType: 'labels.text.stroke',
							stylers: [
								{
									color: '#ffffff'
								}
							]
						}
					],
					zoom: parseInt( el.attr( 'data-zoom' ) )
				});
				let marker = new google.maps.Marker({
					map: map,
					position: coordinates
				});
				let infoWindow = new google.maps.InfoWindow({
					content: el[0].hasAttribute( 'data-title' ) ?
						el.attr( 'data-title' ) :
						null
				});
				marker.addListener( 'click', () => {
					infoWindow.open( map, marker );
				});
			});
		});
	}
});
